/**
 * Kept out of `constants.ts` so MCP widgets can import it: that module reads `process.env` at
 * module scope, and a widget bundle has no `process`.
 */
export const DEFAULT_TIMEZONE = 'Asia/Jerusalem';
